import React from 'react';
import { TextDomain } from '../constants/TextDomain';
import { Alcohol } from '../models/Alcohol';
import './NutritionsTable.css';

interface NutritionsTableProps {
    item: Alcohol;
}

const { __ } = window.wp.i18n;

const NutritionsTable: React.FC<NutritionsTableProps> = (props) => {
    const { item } = props;

    return (
        <table className="nutrition_table">
            <caption>
                {__('Average nutritional value', TextDomain)}
                <span style={{ fontWeight: 300 }}> 100ml</span>
            </caption>
            <tr>
                <td>{__('Alcohol volume', TextDomain)}</td>
                <td className="nutrition_table_item_value" style={{ fontWeight: 'bold' }}>
                    {item.alcohol_less_than && ~~item.alcohol_less_than === 1 ? '<' : ''}
                    {item.alcohol}%
                </td>
            </tr>

            <tr>
                <td>{__('Energy value', TextDomain)}</td>
                <td className="nutrition_table_item_value" style={{ fontWeight: 'bold' }}>
                    {item.energy_value_kj} kJ
                </td>
            </tr>
            <tr>
                <td>{__('Energy value', TextDomain)}</td>
                <td className="nutrition_table_item_value" style={{ fontWeight: 'bold' }}>
                    {item.energy_value_kcal} kcal
                </td>
            </tr>
            <tr>
                <td>{__('Fats', TextDomain)}</td>
                <td className="nutrition_table_item_value" style={{ fontWeight: 'bold' }}>
                    {item.fat} g
                </td>
            </tr>
            <tr>
                <td>{__('Saturated fatty acids', TextDomain)}</td>
                <td className="nutrition_table_item_value" style={{ fontWeight: 'bold' }}>
                    {item.saturated_fatty_acids} g
                </td>
            </tr>
            <tr>
                <td>{__('Carbohydrates', TextDomain)}</td>
                <td className="nutrition_table_item_value" style={{ fontWeight: 'bold' }}>
                    {item.carbohydrates} g
                </td>
            </tr>
            <tr>
                <td>{__('Sugars', TextDomain)}</td>
                <td className="nutrition_table_item_value" style={{ fontWeight: 'bold' }}>
                    {item.sugars_less_than && ~~item.sugars_less_than === 1 ? '<' : ''} {item.sugars} g
                </td>
            </tr>
            <tr>
                <td>{__('Proteins', TextDomain)}</td>
                <td className="nutrition_table_item_value" style={{ fontWeight: 'bold' }}>
                    {item.protein_less_than && ~~item.protein_less_than === 1 ? '<' : ''} {item.protein} g
                </td>
            </tr>
            <tr>
                <td>{__('Salt', TextDomain)}</td>
                <td className="nutrition_table_item_value" style={{ fontWeight: 'bold' }}>
                    {item.salt} mg
                </td>
            </tr>
        </table>
    );
};

export default NutritionsTable;
